<template>
    <v-container class="q-drug-list">
        <v-card>
            <v-card-title>
                Drugs covered by QuilityRx
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table
                :headers="headers"
                :items="drugs"
                :search="search"
                :footer-props="{itemsPerPageOptions:[10,25,50,100]}"
                :options="{itemsPerPage:10}"
                :loading="drugsLoading"
            ></v-data-table>
        </v-card>
    </v-container>
</template>
<script>
import GlicAPI from './GlicAPI.js'
export default {
    props: [],
    data: function() {
        return {
            drugsLoading: true,
            drugs: [],
            search: '',
            headers: [
                { text: 'Drug Name', value: 'Drug_Name' },
            ],
        }
    },
    mounted: function() {
        var g = this
        GlicAPI.alldrugs().then(function(json) {
            g.drugs = json[0].data
            g.drugsLoading = false
        }).catch(function() {
            g.drugsLoading = false
        });
    },
    computed: {
        
    },
    methods: {
        
    },
    watch: {
        'drugs': function(newV) {
            // console.log("watch drugs count", newV.length)
        }
    },
    components: {
        
    }
}
</script>
<style>
</style>